import React, { useState, useEffect } from 'react';
import AuthHero from '../components/AuthHero';
import { Link, useNavigate, useLocation } from 'react-router-dom';
import axios from 'axios';

const API = 'https://api.starhubcreative.id';

export default function Register() {
  const [form, setForm] = useState({ name: '', email: '', password: '', phone: '', artist_name: '', referral_code: '' });
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const [refValid, setRefValid] = useState(null);
  const navigate = useNavigate();
  const location = useLocation();
  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const ref = params.get('ref');
    if (ref) setForm(f => ({ ...f, referral_code: ref.toUpperCase() }));
  }, [location]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);
    try {
      await axios.post(`${API}/api/auth/register`, form);
      navigate('/login?registered=true');
    } catch (err) {
      setError(err.response?.data?.error || 'Registrasi gagal');
    } finally {
      setLoading(false);
    }
  };

  const fields = [
    { key: 'name', label: 'Nama Lengkap', type: 'text', placeholder: 'Nama kamu', required: true },
    { key: 'artist_name', label: 'Nama Artis/Channel', type: 'text', placeholder: 'Nama artis atau channel YouTube', required: true },
    { key: 'email', label: 'Email', type: 'email', placeholder: 'email@kamu.com', required: true },
    { key: 'phone', label: 'No. WhatsApp', type: 'tel', placeholder: '08xxxxxxxxxx', required: false },
    { key: 'password', label: 'Password', type: 'password', placeholder: 'Min 6 karakter', required: true },
  ];

  return (
    <div className="sh-auth" style={{
      minHeight: '100vh',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      padding: 20,
      background: 'transparent'
    }}>
      <AuthHero />
      <div className="sh-auth-card" style={{
        width: '100%',
        maxWidth: 440,
        background: '#FFFFFF', boxShadow: '0 4px 24px rgba(17,24,39,0.06)',
        border: '1px solid #E5E7EB',
        borderRadius: 16,
        padding: 32
      }}>
        <img src="/logo-full-v2.png" alt="Starhub Creative" style={{ height: 56, marginBottom: 24 }} />

        <h1 style={{ fontSize: 24, fontWeight: 700, color: '#111827', marginBottom: 4 }}>Daftar Akun</h1>
        <p style={{ fontSize: 14, color: '#6B7280', marginBottom: 28 }}>Mulai distribusi konten otomatis</p>

        {error && (
          <div style={{ background: 'rgba(239,68,68,0.16)', border: '1px solid #ef4444', color: '#ef4444', padding: '10px 14px', borderRadius: 8, fontSize: 14, marginBottom: 16 }}>
            {error}
          </div>
        )}

        <form onSubmit={handleSubmit} autoComplete="on">
          {fields.map(f => (
            <div key={f.key} style={{ marginBottom: 14 }}>
              <label style={{ display: 'block', fontSize: 13, fontWeight: 500, color: '#6B7280', marginBottom: 6 }}>
                {f.label} {f.required && <span style={{ color: '#ef4444' }}>*</span>}
              </label>
              <input
                type={f.type}
                placeholder={f.placeholder}
                value={form[f.key]}
                onChange={e => setForm({ ...form, [f.key]: e.target.value })}
                required={f.required}
                style={{ fontSize: 16 }}
              />
            </div>
          ))}

          <div style={{ marginBottom: 14 }}>
            <label style={{ display: 'block', fontSize: 13, fontWeight: 500, color: '#6B7280', marginBottom: 6 }}>
              Kode Referral <span style={{ fontSize: 11, color: '#6B7280' }}>(opsional)</span>
            </label>
            <input
              type="text"
              placeholder="Masukkan kode referral..."
              value={form.referral_code}
              onChange={e => setForm({ ...form, referral_code: e.target.value.toUpperCase() })}
              style={{ fontSize: 14, textTransform: 'uppercase' }}
            />
            {form.referral_code && (
              <div style={{ fontSize: 11, color: '#10b981', marginTop: 4 }}>
                🎉 Kode referral akan memberikan diskon untuk plan pertama kamu!
              </div>
            )}
          </div>
          <button
            type="submit"
            className="btn btn-gold"
            style={{ width: '100%', marginTop: 8, padding: 14, fontSize: 16 }}
            disabled={loading}
          >
            {loading ? 'Loading...' : 'Daftar Sekarang'}
          </button>
        </form>

        <p style={{ textAlign: 'center', marginTop: 24, fontSize: 14, color: '#6B7280' }}>
          Sudah punya akun? <Link to="/login" style={{ color: '#FF5722', textDecoration: 'none', fontWeight: 500 }}>Login</Link>
        </p>
      </div>
    </div>
  );
}
